import { render, staticRenderFns } from "./MultiselectItem.vue?vue&type=template&id=88ff0bfa&scoped=true&"
import script from "./MultiselectItem.vue?vue&type=script&lang=js&"
export * from "./MultiselectItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectItem.vue?vue&type=style&index=0&id=88ff0bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ff0bfa",
  null
  
)

export default component.exports